module.exports = "https://cdn.thelire.com/ins/resource/lh_store_vip_personal.bba23de5772b061b6d180900044951a6.png";